export default __webpack_public_path__ + "static/media/post-icu.283fa949.png";